import { ColDef, ColGroupDef } from 'ag-grid-community';
import { MenuItemRole } from '../../RolePanelTypes';
import { BasePermissionGrid } from './BasePermissionGrid';

export class MenuItemRoleGrid extends BasePermissionGrid<MenuItemRole> {
    id: string = 'MenuItemRoles';
    gridClass: string = 'permissionGrid';
    
    protected endpoint: string = '/rolePanel/menuItemRoles';

    protected getColumnDefs(): (ColDef<any, any> | ColGroupDef<any>)[] {
        return [
            { field: 'Name', headerName: 'Menu Item Name', flex: 3, resizable: false },
            {
                field: 'AllowSelect',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
            {
                field: 'AllowAddNew',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
            {
                field: 'AllowUpdate',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
            {
                field: 'AllowDelete',
                flex: 1,
                resizable: false,
                cellRendererParams: { disabled: false },
            },
        ];
    }
}
